import makeStyles from '@mui/styles/makeStyles';

export const useSearchBarStyles = makeStyles((theme) => ({
  searchIcon: {
    color: theme.palette.button.backgroundColor,
  },
}));
